import React, { useContext } from "react";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Container } from "react-bootstrap";
import { StatusERTDetailsContext } from "../StatusERTDetailsView";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import TableBody from "../../../constants/dummyData.json";
import DataTable from "../../../components/DataTableComponent/DataTable";
import "./statusERTDetailsPage.css";

const StatusERTDetailsPage = ({ textContents }) => {
  const { goBack, previousPage, previousScreen, ertDetail } = useContext(
    StatusERTDetailsContext
  );

  const ERTdata = TableBody.visitorsMapping;
  const tableHeaderStatus = [
    {
      title: "Name & Contact",
      prop: "EmployeeName",
      cell: (row) => (
        <div className="ertHeaderEvacuation">
          <div>{row.EmployeeName}</div>
          <span>{row.ContactNo}</span>
        </div>
      ),
    },
    { title: "Employee Code", prop: "EmployeeCode" },
    { title: "Zone", prop: "DeviceFName" },
    { title: "Working Unit", prop: "WorkingUnit" },
    // { title: "Contact No", prop: "ContactNo" },
    //Using EmergencyContact since some cross dependency in backend
    { title: "Supervisor No", prop: "EmergencyContact" },
  ];

  const tableHeader = [
    { title: "Name", prop: "EmployeeName" },
    { title: "Email", prop: "Email" },
    { title: "Contact No", prop: "ContactNo" },
  ];

  return (
    <div className="categoryPageERT">
      <TopBar />
      <Container>
        <div className="filterContainerZoneERTDeatail">
          <div className="arrowContainerERTDeatail" onClick={() => goBack()}>
            <img
              src={LeftArrow}
              alt="img"
              className="leftArrowZoneERTDeatail back-arrow"
            />
          </div>
          <div className="filterByContainerZoneERTDeatail">
            <span className="filterByZoneText">{previousPage}</span>
          </div>
        </div>
        {ertDetail == null || undefined ? (
          <div className="filterByZoneText">No data</div>
        ) : (
          <div className="tableContainerStatusZoneERTDeatail">
            {previousScreen == null ? (
              <DataTable
                tableData={ertDetail}
                header={tableHeader}
                isPagination={false}
              />
            ) : (
              <DataTable
                tableData={ertDetail}
                header={tableHeaderStatus}
                isPagination={false}
              />
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default StatusERTDetailsPage;
